import { Group as TGroup } from 'three'
import type { Object3D } from 'three'

class Group extends TGroup {
  constructor() {
    super()
  }

  /**
   * add model
   * @param object
   */
  public addModel(object: Object3D) {
    super.add(object)
  }
}

export default Group